import Immutable from 'immutable';
import {
  SEARCH_UPDATE,
  SEARCH_SET_PAGES,
  SEARCH_SCHOOLS_UPDATE,
  SEARCH_UPDATE_COURSES,
  SEARCH_INSTITUTIONS_UPDATE,
  SEARCH_VALUE_INSTITUTIONS_UPDATE,
} from './actions';
import { CREATE_PAGE_SUCCESS } from '../Pages/actions';

const DEFAULT_STATE = Immutable.fromJS({
  byQueryId: {},
  pagesByPath: {},
  institutions: {
    byQueryId: {},
    currentSearch: {},
  },
});

export function Searches(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case SEARCH_UPDATE: {
      const { queryId, pagePaths } = action;
      return state.set(
        'byQueryId',
        state.get('byQueryId').set(queryId, Immutable.fromJS(pagePaths))
      );
    }
    case CREATE_PAGE_SUCCESS:
    case SEARCH_SET_PAGES: {
      const { pages } = action;
      const pagesByPath = Immutable.fromJS(pages).reduce((current, page) => {
        return current.set(page.get('path'), page);
      }, Immutable.Map());

      return state.mergeIn(['pagesByPath'], pagesByPath);
    }
    case SEARCH_UPDATE_COURSES: {
      const { queryId, coursePaths } = action;
      return state.set(
        'byQueryId',
        state.get('byQueryId').set(queryId, Immutable.fromJS(coursePaths))
      );
    }
    case SEARCH_SCHOOLS_UPDATE: {
      const { queryId, schools } = action;
      return state.set(
        'byQueryId',
        state.get('byQueryId').set(queryId, Immutable.fromJS(schools))
      );
    }
    case SEARCH_INSTITUTIONS_UPDATE: {
      const { queryId, institutions } = action;
      const resultMap = Immutable.fromJS(institutions);
      const results = resultMap.get('results').map((i) => i.get('path'));

      return state.setIn(
        ['institutions', 'byQueryId', queryId],
        resultMap.set('results', results)
      );
    }
    case SEARCH_VALUE_INSTITUTIONS_UPDATE: {
      const { query, id } = action;
      return state.setIn(['institutions', 'currentSearch', id], query);
    }
    default: {
      return state;
    }
  }
}
